/** @typedef {{ category?: string | null; tags?: string[] | null }} EventCategoryLike */

const ALLOWED_EVENT_CATEGORIES = new Set([
  "overlanding",
  "hiking_backpacking",
  "wilderness_survival",
  "snow_winter_sports",
  "climbing",
  "photography",
  "foraging",
  "leaf_peeping",
  "wildflower",
  "wildlife_birding",
  "paddling_rafting",
  "snorkeling_freediving",
  "hunting",
  "fishing",
]);

const LEGACY_TAG_ALIASES = {
  "mushroom-foraging": "foraging",
  "wild-plants": "foraging",
  coastal: "foraging",
  "wilderness-skills": "foraging",
};

/** Activity tags that map to a host browse category (cooking/workshop does not). */
const TAG_TO_CATEGORY = {
  foraging: "foraging",
  hunting: "hunting",
  fishing: "fishing",
};

const TAG_RESOLVE_ORDER = ["fishing", "hunting", "foraging"];

function asString(value) {
  return typeof value === "string" ? value.trim() : "";
}

function normalizeLegacyTagSlug(value) {
  const s = asString(value).toLowerCase();
  if (TAG_TO_CATEGORY[s]) {
    return s;
  }
  return LEGACY_TAG_ALIASES[s] || null;
}

function sanitizeEventCategory(value) {
  const slug = asString(value).toLowerCase();
  return ALLOWED_EVENT_CATEGORIES.has(slug) ? slug : "";
}

function resolveEventCategoryFromTags(tags) {
  if (!Array.isArray(tags)) {
    return "";
  }

  const normalized = [];
  for (const raw of tags) {
    const slug = normalizeLegacyTagSlug(raw);
    if (slug && !normalized.includes(slug)) {
      normalized.push(slug);
    }
  }

  for (const tag of TAG_RESOLVE_ORDER) {
    if (normalized.includes(tag)) {
      return TAG_TO_CATEGORY[tag];
    }
  }

  return "";
}

/**
 * @param {EventCategoryLike | null | undefined} event
 * @returns {string} canonical category slug or empty string
 */
function resolveEventCategory(event) {
  const fromField = sanitizeEventCategory(event?.category);
  if (fromField) {
    return fromField;
  }
  return resolveEventCategoryFromTags(event?.tags);
}

module.exports = {
  ALLOWED_EVENT_CATEGORIES,
  sanitizeEventCategory,
  resolveEventCategoryFromTags,
  resolveEventCategory,
};
